var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEnvelopeIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1073_434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.2801 5.80471L12.2196 2.25576L12.2196 7.95749C12.2196 8.08622 12.1177 8.18581 11.9991 8.18581L2.02337 8.18572C1.90482 8.18572 1.80285 8.0861 1.80285 7.95749V2.25583L6.74227 5.80471L6.74244 5.80483C6.82283 5.86241 6.91688 5.89144 7.01123 5.89144C7.10556 5.89144 7.19966 5.86243 7.28002 5.80476L7.2801 5.80471ZM11.999 0.87002H2.02337C1.38575 0.87002 0.872461 1.39854 0.872461 2.04193V7.95756C0.872461 8.60093 1.38573 9.12956 2.02337 9.12956H11.9991C12.6368 9.12956 13.15 8.60093 13.15 7.95756L13.1499 2.04193C13.1499 1.39857 12.6367 0.870068 11.9991 0.87002C11.9991 0.87002 11.9991 0.87002 11.999 0.87002ZM7.01132 4.84152L2.79716 1.8137H11.2255L7.01132 4.84152Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1073_434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 10,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvelopeIcon);
export default __webpack_public_path__ + "static/media/envelopeIcon.8ad993cd.svg";
export { ForwardRef as ReactComponent };